import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Row, Label,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle, DropdownItem, Input
} from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import Tooltip from './Tooltip';
import Switch from 'rc-switch';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { htmlEditButton } from 'quill-html-edit-button';
import LegendsList from './legendsList';

Quill.register('modules/htmlEditButton', htmlEditButton);

let arr = [];
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
  htmlEditButton: {},
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',

];

function CustomEmails({
  integration,
  integrationProperties,
  allProperties,
  saveIntegration,
  locale,
  botSettings
}) {
  const [selectedItem, setSelectedItem] = useState('Voucher Email');
  const [setting, setSetting] = useState(botSettings);
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState(integration.properties);
  const [name, setName] = useState('');
  const [isAivaHide, setIsAivaHide] = useState(integration.isaivaHide || false);
  const [isCustom, setIsCoustom] = useState(botSettings.voucherEmail !== undefined ? botSettings.voucherEmail.isEnabled : false);
  const [includedLabels, setIncludedLabels] = useState(botSettings.voucherEmail !== undefined ? botSettings.voucherEmail.labels : "");
  const [giftLabels, setGiftLabels] = useState(
    botSettings.giftEmail !== undefined ? botSettings.giftEmail.labels : "",
  );
  const [ecardLabels, setECardLabels] = useState(
    botSettings.eCardEmail !== undefined ? botSettings.eCardEmail.labels : ""
  );
  const [eGiftCardLabels, setEGiftCardLabels] = useState(
    botSettings.eGiftEmail !== undefined ? botSettings.eGiftEmail.labels : "",
  );
  const [voucheEmail, setVoucheEmail] = useState([
    {
      statement: botSettings.voucherEmail !== undefined ? botSettings.voucherEmail.email : "",
      languageCode: locale,
    },
  ]);
  const [voucherGift, setVoucherGift] = useState([
    {
      statement: botSettings.giftEmail.email !== undefined ? botSettings.giftEmail.email : "",
      languageCode: locale,
    },
  ]);
  const [ecardEmail, setECardEmail] = useState([
    {
      statement: botSettings.eCardEmail !== undefined ? botSettings.eCardEmail.email : "",
      languageCode: locale,
    },
  ]);
  const [gifteEmail, setGiftEmail] = useState([
    {
      statement: botSettings.eGiftEmail !== undefined ? botSettings.eGiftEmail.email : "",
      languageCode: locale,
    },
  ]);
  const [html, setHtml] = useState(botSettings.voucherEmail !== undefined ? botSettings.voucherEmail.email : "");
  const [giftVoucherHtml, setGiftVoucherHtml] = useState(botSettings.giftEmail.email !== undefined ? botSettings.giftEmail.email : "");
  const [eCardHtml, setECardHtml] = useState(botSettings.eCardEmail !== undefined ? botSettings.eCardEmail.email : "");
  const [eGiftHtml, setEGiftHtml] = useState(botSettings.eGiftEmail !== undefined ? botSettings.eGiftEmail.email : "");

  const parseToDOM = (str) => {
    let div = document.createElement('div');
    div.innerHTML = str;    
    return div.innerHTML;
  }

  const getLocalStatement = (statements) => {    
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const handleSwitchChange = (value) => {
    setIsCoustom(value);
  };


  const handleSave = () => {
    setting.voucherEmail = { email: html, isenabled: isCustom ? true : false, labels: includedLabels };
    setting.giftEmail = { email: giftVoucherHtml, isenabled: isCustom ? true : false, labels: giftLabels };
    setting.eCardEmail = { email: eCardHtml, isenabled: isCustom ? true : false, labels: ecardLabels };
    setting.eGiftEmail = { email: eGiftHtml, isenabled: isCustom ? true : false, labels: eGiftCardLabels };    
    saveIntegration({ pageSettings: setting, botSetting: setting, isaivaHide: isAivaHide });
    arr = [];
    setList([]);
    setIsEditing(!isEditing);
  };

  const handleSelected = (name) => {
    if (includedLabels.split(',').includes(name.trim(''))) {
      let includeItemsList = includedLabels.split(',');
      let itemsList = includeItemsList.filter((e) => e !== name);
      if (name === 'name') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@name@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'image') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@image@@', '');
        saveSelectedEmail(obj)
      }
      if (name === 'number') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@number@@', '');
        saveSelectedEmail(obj);
      }
      if (name === 'date') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@date@@', '');
        saveSelectedEmail(obj);
      }
      if (name === 'hotelLogo') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@hotelLogo@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'hotelName') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@hotelName@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'details') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@details@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'conditions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'instructions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      setIncludedLabels(
        itemsList.toString(),
      );

    } else {
      if (name === 'name') {
        let obj = getSelectedEmail();
        obj = obj + ' @@name@@'
        saveSelectedEmail(obj)
      }
      if (name === 'number') {
        let obj = getSelectedEmail();
        obj = obj + ' @@number@@'
        saveSelectedEmail(obj)
      }
      if (name === 'date') {
        let obj = getSelectedEmail();
        obj = obj + ' @@date@@'
        saveSelectedEmail(obj)
      }
      if (name === 'image') {
        let obj = getSelectedEmail();
        obj = obj + ' @@image@@'
        saveSelectedEmail(obj)
      }

      if (name === 'hotelLogo') {
        let obj = getSelectedEmail();
        obj = obj + ' @@hotelLogo@@'
        saveSelectedEmail(obj)
      }

      if (name === 'hotelName') {
        let obj = getSelectedEmail();
        obj = obj + ' @@hotelName@@'
        saveSelectedEmail(obj)
      }

      if (name === 'details') {
        let obj = getSelectedEmail();
        obj = obj + ' @@details@@'
        saveSelectedEmail(obj)
      }

      if (name === 'conditions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'instructions') {
        let obj = getSelectedEmail();
        obj = obj + ' @@instructions@@'
        saveSelectedEmail(obj)
      }

      setIncludedLabels(
        includedLabels + ',' + name,
      );
    }

  };

  const handleGiftSelected = (name) => {
    if (giftLabels.split(',').includes(name.trim(''))) {
      let includeItemsList = giftLabels.split(',');
      let itemsList = includeItemsList.filter((e) => e !== name);
      if (name === 'name') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@name@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'image') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@image@@', '');
        saveSelectedEmail(obj)
      }
      if (name === 'number') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@number@@', '');
        saveSelectedEmail(obj);
      }
      if (name === 'date') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@date@@', '');
        saveSelectedEmail(obj);
      }
      if (name === 'hotelLogo') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@hotelLogo@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'hotelName') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@hotelName@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'details') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@details@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'conditions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'instructions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      setGiftLabels(
        itemsList.toString(),
      );

    } else {
      if (name === 'name') {
        let obj = getSelectedEmail();
        obj = obj + ' @@name@@'
        saveSelectedEmail(obj)
      }
      if (name === 'number') {
        let obj = getSelectedEmail();
        obj = obj + ' @@number@@'
        saveSelectedEmail(obj)
      }
      if (name === 'date') {
        let obj = getSelectedEmail();
        obj = obj + ' @@date@@'
        saveSelectedEmail(obj)
      }
      if (name === 'image') {
        let obj = getSelectedEmail();
        obj = obj + ' @@image@@'
        saveSelectedEmail(obj)
      }

      if (name === 'hotelLogo') {
        let obj = getSelectedEmail();
        obj = obj + ' @@hotelLogo@@'
        saveSelectedEmail(obj)
      }

      if (name === 'hotelName') {
        let obj = getSelectedEmail();
        obj = obj + ' @@hotelName@@'
        saveSelectedEmail(obj)
      }

      if (name === 'details') {
        let obj = getSelectedEmail();
        obj = obj + ' @@details@@'
        saveSelectedEmail(obj)
      }

      if (name === 'conditions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'instructions') {
        let obj = getSelectedEmail();
        obj = obj + ' @@instructions@@'
        saveSelectedEmail(obj)
      }

      setGiftLabels(
        giftLabels + ',' + name,
      );
    }

  };

  const handleECardLabels = (name) => {
    if (ecardLabels.split(',').includes(name.trim(''))) {
      let includeItemsList = ecardLabels.split(',');
      let itemsList = includeItemsList.filter((e) => e !== name);
      if (name === 'name') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@name@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'image') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@image@@', '');
        saveSelectedEmail(obj)
      }
      if (name === 'number') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@number@@', '');
        saveSelectedEmail(obj);
      }
      if (name === 'date') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@date@@', '');
        saveSelectedEmail(obj);
      }
      if (name === 'hotelLogo') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@hotelLogo@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'hotelName') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@hotelName@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'details') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@details@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'conditions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'instructions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      setECardLabels(
        itemsList.toString(),
      );

    } else {
      if (name === 'name') {
        let obj = getSelectedEmail();
        obj = obj + ' @@name@@'
        saveSelectedEmail(obj)
      }
      if (name === 'number') {
        let obj = getSelectedEmail();
        obj = obj + ' @@number@@'
        saveSelectedEmail(obj)
      }
      if (name === 'date') {
        let obj = getSelectedEmail();
        obj = obj + ' @@date@@'
        saveSelectedEmail(obj)
      }
      if (name === 'image') {
        let obj = getSelectedEmail();
        obj = obj + ' @@image@@'
        saveSelectedEmail(obj)
      }

      if (name === 'hotelLogo') {
        let obj = getSelectedEmail();
        obj = obj + ' @@hotelLogo@@'
        saveSelectedEmail(obj)
      }

      if (name === 'hotelName') {
        let obj = getSelectedEmail();
        obj = obj + ' @@hotelName@@'
        saveSelectedEmail(obj)
      }

      if (name === 'details') {
        let obj = getSelectedEmail();
        obj = obj + ' @@details@@'
        saveSelectedEmail(obj)
      }

      if (name === 'conditions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'instructions') {
        let obj = getSelectedEmail();
        obj = obj + ' @@instructions@@'
        saveSelectedEmail(obj)
      }

      setECardLabels(
        ecardLabels + ',' + name,
      );
    }

  };

  const handleEGiftCardLabels = (name) => {
    if (eGiftCardLabels.split(',').includes(name.trim(''))) {
      let includeItemsList = eGiftCardLabels.split(',');
      let itemsList = includeItemsList.filter((e) => e !== name);
      if (name === 'name') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@name@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'image') {
        let obj = getSelectedEmail();        
        obj = obj.replace('@@image@@', '');
        saveSelectedEmail(obj)
      }
      if (name === 'number') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@number@@', '');
        saveSelectedEmail(obj);
      }
      if (name === 'date') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@date@@', '');
        saveSelectedEmail(obj);
      }
      if (name === 'hotelLogo') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@hotelLogo@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'hotelName') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@hotelName@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'details') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@details@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'conditions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@conditions@@', '');
        saveSelectedEmail(obj)
      }

      if (name === 'instructions') {
        let obj = getSelectedEmail();
        obj = obj.replace('@@instructions@@', '');
        saveSelectedEmail(obj)
      }

      setEGiftCardLabels(
        itemsList.toString(),
      );

    } else {
      if (name === 'name') {
        let obj = getSelectedEmail();
        obj = obj + ' @@name@@'
        saveSelectedEmail(obj)
      }
      if (name === 'number') {
        let obj = getSelectedEmail();
        obj = obj + ' @@number@@'
        saveSelectedEmail(obj)
      }
      if (name === 'date') {
        let obj = getSelectedEmail();
        obj = obj + ' @@date@@'
        saveSelectedEmail(obj)
      }
      if (name === 'image') {
        let obj = getSelectedEmail();
        obj = obj + ' @@image@@'
        saveSelectedEmail(obj)
      }

      if (name === 'hotelLogo') {
        let obj = getSelectedEmail();
        obj = obj + ' @@hotelLogo@@'
        saveSelectedEmail(obj)
      }

      if (name === 'hotelName') {
        let obj = getSelectedEmail();
        obj = obj + ' @@hotelName@@'
        saveSelectedEmail(obj)
      }

      if (name === 'details') {
        let obj = getSelectedEmail();
        obj = obj + ' @@details@@'
        saveSelectedEmail(obj)
      }

      if (name === 'conditions') {
        let obj = getSelectedEmail();
        obj = obj + ' @@conditions@@'
        saveSelectedEmail(obj)
      }

      if (name === 'instructions') {
        let obj = getSelectedEmail();
        obj = obj + ' @@instructions@@'
        saveSelectedEmail(obj)
      }

      setEGiftCardLabels(
        eGiftCardLabels + ',' + name,
      );
    }
  };





  const getSelectedEmail = () => {    
    if (selectedItem === 'Voucher Email')
      return html;
    else if (selectedItem == "Gift Voucher Email")
      return giftVoucherHtml;
    else if (selectedItem == "E Card Email")
      return eCardHtml;
    else if (selectedItem == "E Gift Card Email")
      return eGiftHtml;
  };
  const saveSelectedEmail = (email) => {
    if (selectedItem === 'Voucher Email')
      setHtml(email);
    else if (selectedItem == "Gift Voucher Email")
      setGiftVoucherHtml(email);
    else if (selectedItem == "E Card Email")
      setECardHtml(email);
    else if (selectedItem == "E Gift Card Email")
      setEGiftHtml(email);
  };

  const Show = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
              Custom Emails (Coming Soon)    
          </h6>
        </div>
        <Separator className="mb-3" />
        <div className='text-right mb-3'>
          <Switch
            //className="custom-switch custom-switch-primary custom-switch-small integrationremove"
            checked={isCustom}
            onChange={(primary) => handleSwitchChange(primary)}
          />
        </div>
        <div className='text-right mb-3'>
          <UncontrolledDropdown>
            <DropdownToggle>{selectedItem} </DropdownToggle>
            <DropdownMenu>
              <DropdownItem value="Voucher Email" onClick={(e) => setSelectedItem(e.target.value)}>
                Voucher Email
              </DropdownItem>
              <DropdownItem value="Gift Voucher Email" onClick={(e) => setSelectedItem(e.target.value)}>
                Gift Voucher Email
              </DropdownItem>
              <DropdownItem value="E Card Email" onClick={(e) => setSelectedItem(e.target.value)}>
                E Card Email
              </DropdownItem>
              <DropdownItem value="E Gift Card Email" onClick={(e) => setSelectedItem(e.target.value)}>
                E Gift Card Email
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
        {selectedItem == "Voucher Email" && <Fragment>
          <Row className="mb-2">
            <Colxx sm={12} className="mb-3">
              {ReactHtmlParser(html)}
            </Colxx>
            <Colxx sm={12} className="mb-3">
              <Input
                type="textarea"
                value={html}
                onChange={(e) => setHtml(e.target.value)
                }
                style={{ height: '10rem' }}
                name="html"
              />
            </Colxx>
          </Row>

          <Row className="mb-2">
            <Colxx sm={12} className="mb-3">
              <Label className="text-center">Legends</Label>
              <LegendsList selected={includedLabels} handleSelected={handleSelected} >

              </LegendsList>
            </Colxx>
          </Row></Fragment>}
        {selectedItem == "Gift Voucher Email" && <Fragment>
          <Row>
            <Colxx sm={12} className="mb-3">
              {ReactHtmlParser(giftVoucherHtml)}
            </Colxx>
            <Colxx sm={12} className="mb-3">
              <Input
                type="textarea"
                value={giftVoucherHtml}
                onChange={(e) => setGiftVoucherHtml(e.target.value)
                }
                style={{ height: '10rem' }}
                name="html"
              />
            </Colxx>
          </Row>
          <Row className="mb-2">
            <Colxx sm={12} className="mb-3">
              <Label className="text-center">Legends</Label>
              <LegendsList selected={giftLabels} handleSelected={handleGiftSelected}></LegendsList>
            </Colxx>
          </Row></Fragment>}

        {selectedItem == "E Card Email" && <Fragment>
          <Row>
            <Colxx sm={12} className="mb-3">
              {ReactHtmlParser(eCardHtml
              )}
            </Colxx>
            <Colxx sm={12} className="mb-3">
              <Input
                type="textarea"
                value={eCardHtml}
                onChange={(e) => setECardHtml(e.target.value)
                }
                style={{ height: '10rem' }}
                name="html"
              />
            </Colxx>
          </Row>
          <Row className="mb-2">
            <Colxx sm={12} className="mb-3">
              <Label className="text-center">Legends</Label>
              <LegendsList selected={ecardLabels} handleSelected={handleECardLabels}></LegendsList>
            </Colxx>
          </Row></Fragment>}

        {selectedItem == "E Gift Card Email" && <Fragment>
          <Row>
            <Colxx sm={12} className="mb-3">
              {ReactHtmlParser(eGiftHtml)}
            </Colxx>
            <Colxx sm={12} className="mb-3">
              <Input
                type="textarea"
                value={eGiftHtml}
                onChange={(e) => setEGiftHtml(e.target.value)
                }
                style={{ height: '10rem' }}
                name="html"
              />
            </Colxx>
          </Row>
          <Row className="mb-2">
            <Colxx sm={12} className="mb-3">
              <Label className="text-center">Legends</Label>
              <LegendsList selected={eGiftCardLabels} handleSelected={handleEGiftCardLabels}></LegendsList>
            </Colxx>
          </Row></Fragment>}
        <div className='text-center'>
          <ButtonGroup className="mb-2 text-center" style={{ marginTop: '20px' }}>
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button
              size="xs"
              color="dark"
              outline
              onClick={() => setIsEditing(!isEditing)}
            >
              Cancel
            </Button>
          </ButtonGroup>
        </div>
      </CardBody>


    );
  };


  return <Card className="mb-4">{Show()}</Card>;
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return {
    locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(CustomEmails));